import { create } from "zustand";
import {
  PDA1122_R01InputItem,
  PDA1122_R01OrderDto,
  PDA1122_R01ScanResult,
  PDA1122_R01SearchParams,
} from "./PDA1122_R01Dto";

export interface PDA1122_R01Store {
  orderList: PDA1122_R01OrderDto[];
  selectedOrder: PDA1122_R01OrderDto | null;
  loading: boolean;
  searchParams: PDA1122_R01SearchParams;
  showList: boolean;
  lotInput: string;
  scanResult: PDA1122_R01ScanResult | null;
  inputList: PDA1122_R01InputItem[];
  savedInputList: PDA1122_R01InputItem[];
  setOrderList: (list: PDA1122_R01OrderDto[]) => void;
  setSelectedOrder: (order: PDA1122_R01OrderDto | null) => void;
  setLoading: (loading: boolean) => void;
  updateSearchParam: (field: keyof PDA1122_R01SearchParams, value: string) => void;
  setShowList: (showList: boolean) => void;
  setLotInput: (lotInput: string) => void;
  setScanResult: (result: PDA1122_R01ScanResult | null) => void;
  setSavedInputList: (list: PDA1122_R01InputItem[]) => void;
  addInput: (item: PDA1122_R01InputItem) => boolean;
  removeInput: (lotNo: string) => void;
  clearInputs: () => void;
  resetDetail: () => void;
  reset: () => void;
}

const formatDate = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

const createInitialSearchParams = (): PDA1122_R01SearchParams => {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  return {
    productOrderNo: "",
    startDate: formatDate(firstDay),
    endDate: formatDate(today),
  };
};

const usePDA1122_R01Store = create<PDA1122_R01Store>((set, get) => ({
  orderList: [],
  selectedOrder: null,
  loading: false,
  searchParams: createInitialSearchParams(),
  showList: true,
  lotInput: "",
  scanResult: null,
  inputList: [],
  savedInputList: [],
  setOrderList: (orderList) => set({ orderList }),
  setSelectedOrder: (selectedOrder) => set({ selectedOrder }),
  setLoading: (loading) => set({ loading }),
  updateSearchParam: (field, value) =>
    set((state) => ({ searchParams: { ...state.searchParams, [field]: value } })),
  setShowList: (showList) => set({ showList }),
  setLotInput: (lotInput) => set({ lotInput }),
  setScanResult: (scanResult) => set({ scanResult }),
  setSavedInputList: (savedInputList) => set({ savedInputList }),
  addInput: (item) => {
    const { inputList, savedInputList } = get();
    if ([...inputList, ...savedInputList].some((input) => input.lotNo === item.lotNo)) {
      return false;
    }
    set((state) => ({ inputList: [item, ...state.inputList] }));
    return true;
  },
  removeInput: (lotNo) =>
    set((state) => ({ inputList: state.inputList.filter((item) => item.lotNo !== lotNo) })),
  clearInputs: () => set({ inputList: [] }),
  resetDetail: () =>
    set({
      selectedOrder: null,
      lotInput: "",
      scanResult: null,
      inputList: [],
      savedInputList: [],
    }),
  reset: () =>
    set({
      orderList: [],
      selectedOrder: null,
      loading: false,
      searchParams: createInitialSearchParams(),
      showList: true,
      lotInput: "",
      scanResult: null,
      inputList: [],
      savedInputList: [],
    }),
}));

export default usePDA1122_R01Store;
